import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import {ProgressBar} from 'primereact/progressbar';
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {InputNumber} from "primereact/inputnumber";

const PurchaseorderitemListComponent = (props) => {

  const {t, view} = props;
  const history = useHistory();
  const {entity, action, id} = useParams();
  const [purchaseorder, setPurchaseorder] = useState({});
  const [purchaseorderitems, setPurchaseorderitems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingItem, setLoadingItem] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [expandedRows, setExpandedRows] = useState(null);
  const [inventoryByMaterial, setInventoryByMaterial] = useState({});
  const [inventoryLoadingByMaterial, setInventoryLoadingByMaterial] = useState({});
  const [technologyOptionsByProjectItem, setTechnologyOptionsByProjectItem] = useState({});
  const [technologyLoadingByProjectItem, setTechnologyLoadingByProjectItem] = useState({});
  const [transferDialogVisible, setTransferDialogVisible] = useState(false);
  const [transferSubmitting, setTransferSubmitting] = useState(false);
  const [transferContext, setTransferContext] = useState({
    parentRow: null,
    invRow: null,
  });
  const [transferQty, setTransferQty] = useState(null);
  const [transferTargetLocationId, setTransferTargetLocationId] = useState(null);
  const [warehouseLocationsByWarehouse, setWarehouseLocationsByWarehouse] = useState({});
  const [warehouseLocationsLoadingByWarehouse, setWarehouseLocationsLoadingByWarehouse] = useState({});
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'position',
    sortOrder: 1,
    filters: view === 'material'
      ? {}
      : {
          'purchase_order': {value: id, matchMode: 'equals'}
        }
  });
  const poStatus = String(purchaseorder?.status || '').toUpperCase();
  const isEditablePurchaseOrder = !purchaseorder?.status || ['NEW', 'IN_PROGRESS'].includes(poStatus);

  const loadLazyTimeout = useRef(null);
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout.current) {
      clearTimeout(loadLazyTimeout.current);
    }
    loadLazyTimeout.current = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams);
      if (view === 'material' && props.materialId) {
        query += `&search[material][operator]==&search[material][value]=${props.materialId}`;
      }
      apiCall('get', '/api/v2/purchase-order-item' + query)
        .then(response => {
          const items = response.data.data.items || [];
          setTotalRecords(response.data.data.total_item_count);
          setPurchaseorderitems(items);
          const projectItemIds = [...new Set(
            items
              .map(item => item?.project_item?.id || item?.project_item)
              .filter(Boolean)
          )];
          projectItemIds.forEach(projectItemId => {
            if (!technologyOptionsByProjectItem[projectItemId] && !technologyLoadingByProjectItem[projectItemId]) {
              loadTechnologiesForProjectItem(projectItemId);
            }
          });
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => setLoading(false));
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  // const copyValueToItems = async (fieldName, fromIndex, value, scope = 'all') => {
  //   if (value === null || value === undefined || value === '') return;
  //   if (!Array.isArray(purchaseorderitems) || purchaseorderitems.length === 0) return;
  //   const targetIndexes = purchaseorderitems
  //     .map((_, i) => i)
  //     .filter(i => {
  //       if (i === fromIndex) return false;
  //       if (scope === 'following') return i > fromIndex;
  //       if (scope === 'previous') return i < fromIndex;
  //       return true;
  //     });
  //   if (targetIndexes.length === 0) return;
  //   setLoadingItem(true);
  //   setPurchaseorderitems(prev => {
  //     const next = [...prev];
  //     for (const i of targetIndexes) {
  //       next[i] = { ...next[i], [fieldName]: value };
  //     }
  //     return next;
  //   });
  //   try {
  //     const requests = targetIndexes.map(i =>
  //       apiCall('patch', `/api/v2/purchase-order-item/${purchaseorderitems[i].id}`, {
  //         [fieldName]: value
  //       })
  //     );
  //     const results = await Promise.allSettled(requests);
  //     const failed = results.filter(r => r.status === 'rejected').length;
  //     if (failed === 0) {
  //       window.App.toastShow('success', 'Sikeres másolás!');
  //     } 
  //     window.App.setState({ rerenderPurchaseorderitemList: Math.random() });
  //   } catch (err) {
  //     window.App.toastShow('error', 'Hiba', err.toString(), '', err.response);
  //   } finally {
  //     setLoadingItem(false);
  //   }
  // };


  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const loadWarehouseLocations = async (warehouseId) => {
    if (!warehouseId) return;
    if (warehouseLocationsByWarehouse[warehouseId]) return;
    setWarehouseLocationsLoadingByWarehouse(prev => ({ ...prev, [warehouseId]: true }));
    try {
      const res = await apiCall(
        'get',
        `/api/v2/warehouse-location?search[warehouse][operator]==&search[warehouse][value]=${warehouseId}&search[type][operator]==&search[type][value]=STORAGE&item_per_page=1000`
      );
      const items = res.data?.data?.items || res.data?.data || [];
      const options = items.map(loc => ({
        label: loc?.code || loc?.name || `#${loc?.id}`,
        value: loc?.id,
        original: loc
      }));
      setWarehouseLocationsByWarehouse(prev => ({ ...prev, [warehouseId]: options }));
    } catch (err) {
      window.App.toastShow('error', t('error'), err.toString(), '', err.response);
      setWarehouseLocationsByWarehouse(prev => ({ ...prev, [warehouseId]: [] }));
    } finally {
      setWarehouseLocationsLoadingByWarehouse(prev => ({ ...prev, [warehouseId]: false }));
    }
  };

  const openTransferDialog = async (parentRow, invRow) => {
    if (!isEditablePurchaseOrder) return;
    setTransferContext({ parentRow, invRow });
    const requestedQty = Math.max(0, Number(parentRow?.quantity || 0));
    setTransferQty(requestedQty);
    setTransferTargetLocationId(null);
    const poWarehouseId = purchaseorder?.warehouse?.id || purchaseorder?.warehouse || null;
    if (poWarehouseId) {
      await loadWarehouseLocations(poWarehouseId);
    }
    setTransferDialogVisible(true);
  };

  const closeTransferDialog = () => {
    if (transferSubmitting) return;
    setTransferDialogVisible(false);
  };

  const loadInventoryForMaterial = async (materialId, force = false) => {
    if (!materialId) return;
    if (!force && inventoryByMaterial[materialId]) return;
    setInventoryLoadingByMaterial(prev => ({ ...prev, [materialId]: true }));
    try {
      const res = await apiCall(
        // 'get', `/api/v2/inventory?search[material][operator]==&search[material][value]=${materialId}`
        'get', `/api/v2/inventory?search[material][operator]==&search[material][value]=${materialId}&search[warehouse_type][operator]=in&search[warehouse_type][value][]=CENTRAL&search[warehouse_type][value][]=CONSIGNMENT`
      );
      const items = res.data?.data?.items || res.data?.data || [];
      setInventoryByMaterial(prev => ({ ...prev, [materialId]: items }));
    } catch (error) {
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      setInventoryByMaterial(prev => ({ ...prev, [materialId]: [] }));
    } finally {
      setInventoryLoadingByMaterial(prev => ({ ...prev, [materialId]: false }));
    }
  };

  const loadTechnologiesForProjectItem = async (projectItemId) => {
    if (!projectItemId) return;
    if (technologyOptionsByProjectItem[projectItemId]) return;
    if (technologyLoadingByProjectItem[projectItemId]) return;
    setTechnologyLoadingByProjectItem(prev => ({ ...prev, [projectItemId]: true }));
    try {
      const res = await apiCall(
        'get',
        `/api/v2/project-item/${projectItemId}/technologies`
      );
      const items = res.data?.data?.items || res.data?.data || [];
      const formatted = items.map(i => ({
        label: i.name,
        value: i.id,
        original: i
      }));
      setTechnologyOptionsByProjectItem(prev => ({
        ...prev,
        [projectItemId]: formatted
      }));
    } catch (err) {
      window.App.toastShow('error', t('error'), err.toString(), '', err.response);
      setTechnologyOptionsByProjectItem(prev => ({
        ...prev,
        [projectItemId]: []
      }));
    } finally {
      setTechnologyLoadingByProjectItem(prev => ({
        ...prev,
        [projectItemId]: false
      }));
    }
  };

  const productionItemBodyTemplate = (rowData) => {
    const currentValue = rowData?.technology?.id || rowData?.technology || null;
    const projectItemId = rowData?.project_item?.id || rowData?.project_item || null;
    const options = (projectItemId && technologyOptionsByProjectItem[projectItemId])
      ? technologyOptionsByProjectItem[projectItemId]
      : [];
    const isLoading = !!(projectItemId && technologyLoadingByProjectItem[projectItemId]);
    const disabled = !projectItemId;
    return (
      <Dropdown
        value={currentValue}
        options={options}
        optionLabel="label"
        optionValue="value"
        showClear
        filter
        disabled={disabled}
        placeholder={
          !projectItemId
            ? t('noProjectItem')
            : (isLoading ? t('loading') : t('selectPlaceholder'))
        }
        title={!projectItemId ? t('technologyListProjectItemHint') : ""}
        className="p-inputtext-sm w-full"
        appendTo={document.body}
        onShow={() => {
          if (!projectItemId) return;
          if (technologyOptionsByProjectItem[projectItemId]) return;
          if (technologyLoadingByProjectItem[projectItemId]) return;
          loadTechnologiesForProjectItem(projectItemId);
        }}
        onChange={(e) => {
          const val = e.value || null;
          setLoadingItem(true);
          apiCall('patch', `/api/v2/purchase-order-item/${rowData.id}`, {
            technology: val
          })
            .then(() => {
              setPurchaseorderitems(prev => prev.map(item =>
                item.id === rowData.id
                  ? { ...item, technology: val }
                  : item
              ));
              window.App.toastShow('success', 'Sikeres mentés!');
            })
            .catch(err => {
              window.App.toastShow('error', t('error'), err.toString(), '', err.response);
            })
            .finally(() => {
              setLoadingItem(false);
            });
        }}
      />
    );
  };

  useEffect(() => {
    loadLazyData();
    if (view !== 'material' && id) {
    apiCall('get', '/api/v2/purchase-order/' + id)
      .then(res => {
        setPurchaseorder(res.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
    }
  }, [id, window.App.state.rerenderPurchaseorderitemList]);

  useEffect(() => {
    if (window.App.urlVars().materialId) {
      setLoadingItem(true);
      apiCall('patch', '/api/v2/purchase-order-item-request-item/' + window.App.urlVars().requestItemId, {
        material: Number(window.App.urlVars().materialId),
      })
        .then(response => {
          window.App.toastShow('success', 'Sikeres kiváltás!');
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          history.push('/procurement/' + entity + '/' + action + '/' + id)
          loadLazyData()
          setLoadingItem(false);
        });
    }
  }, [window.App.urlVars().materialId])

  return (
    <>
      {/*{(props.mode === 'order' && (purchaseorder.status === 'COMPOSED' || purchaseorder.status === 'IN_PROGRESS')) ? (*/}
        <>
          {loadingItem &&
            <ProgressBar mode="indeterminate"
                         style={{
                           height: '5px',
                           position: "absolute",
                           top: 0,
                           left: 0,
                           borderRadius: 0,
                         }}></ProgressBar>
          }
          <DataTable size={localStorage.getItem('scale')}
                     emptyMessage={t('noResults')}
                     value={purchaseorderitems} paginator first={lazyParams.first} totalRecords={totalRecords}
                     onPage={onPage}
                     onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                     onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                     paginatorTemplate={pager} rows={rows}
                     autoLayout={true}
                     filterDisplay="row"
                     responsiveLayout="scroll"
                     stripedRows
                     ref={dt}
                     dataKey="id"
                     rowExpansionTemplate={(rowData) => {
                       const parentRow = rowData;
                       const materialId = parentRow?.material?.id || parentRow?.material;
                       const invLoading = !!inventoryLoadingByMaterial[materialId];
                       const invItems = inventoryByMaterial[materialId] || [];
                       return (
                         <>
                           <div className="expanded-section">
                            <h4 className="expanded-section__title">
                              <i className="pi pi-list" />
                              {t('requestedProducts')}
                            </h4>

                            <div className="expanded-section__content">
                              <DataTable size={"small"}
                                          autoLayout={true}
                                          value={rowData.request_links}
                                          responsiveLayout="scroll"
                                          stripedRows
                                          emptyMessage={t('noProduct')}
                                          dataKey="id"
                              >
                                <Column header={t('columnRequestIdentifier')}
                                        field={"purchase_order_request_item.purchase_order_request.purchase_order_request_number"}></Column>
                                  <Column header={t('columnSubstitutionReason')}
                                          body={(rowData) =>
                                            rowData?.purchase_order_request_item?.substitution_enabled
                                              ? rowData?.purchase_order_request_item?.substitution_type?.name
                                              : t('noSubstitutionPlaceholder')
                                          }>                          
                                  </Column>
                                <Column header={t('columnRequestedProduct')}
                                        field={"purchase_order_request_item.material.name"}></Column>
                                {/* <Column header={t('columnNewProduct')} body={(rowData) => {
                                  if (rowData?.purchase_order_request_item?.substitution_enabled === true && purchaseorder.status === 'COMPOSED') {
                                    if(rowData?.purchase_order_request_item?.material?.id != rowData?.purchase_order_request_item?.original_material?.id) {
                                      return (
                                        <>
                                          <span style={{position: "relative", top:"-6px"}}>{rowData?.purchase_order_request_item?.material?.name}</span>
                                          <a onClick={() => {
                                            history.push('/procurement/' + entity + '/' + action + '/' + id + '?search=material&requestItemId=' + rowData.id)
                                          }}
                                              className={"p-button p-button-sm p-button-warning p-ml-2"}>
                                            <i className={"pi pi-sync"}></i>
                                            &nbsp;
                                            Csere
                                          </a>
                                        </>
                                      )
                                    } else {
                                      return (
                                        <a onClick={() => {
                                          history.push('/procurement/' + entity + '/' + action + '/' + id + '?search=material&requestItemId=' + rowData.id)
                                        }}
                                            className={"p-button p-button-sm p-button-secondary"}>
                                          <i className={"pi pi-sync"}></i>
                                          &nbsp;
                                          Kiváltás
                                        </a>
                                      )
                                    }
                                  }
                                }}></Column> */}
                                {/* <Column
                                    header={t('columnNewProduct')}
                                    // body={(rowData) => {
                                    //   // if (purchaseorder.status !== 'COMPOSED') {
                                    //   //   return null;
                                    //   // }
                                    //   const requestItem = rowData?.purchase_order_request_item;
                                    //   if (!requestItem) return null;
                                    //   const isSubEnabled = rowData?.purchase_order_request_item?.substitution_enabled === true;
                                    //   const buttonLabel = isSubEnabled ? 'Kiváltás' : 'Csere';
                                    //   return (
                                    //     <>
                                    //       {rowData?.purchase_order_request_item?.material?.name && (
                                    //         <span style={{ position: "relative", top: "-6px" }}>
                                    //           {rowData.purchase_order_request_item.material.name}
                                    //         </span>
                                    //       )}
                                    //       <a
                                    //         onClick={() => {
                                    //           history.push(
                                    //             '/procurement/' + entity + '/' + action + '/' + id + '?search=material&requestItemId=' + rowData.id
                                    //           );
                                    //         }}
                                    //         className={
                                    //           "p-button p-button-sm " +
                                    //           (isSubEnabled ? "p-button-secondary p-ml-2" : "p-button-warning p-ml-2")
                                    //         }
                                    //       >
                                    //         <i className="pi pi-sync"></i>
                                    //         &nbsp;
                                    //         {buttonLabel}
                                    //       </a>
                                    //     </>
                                    //   );
                                    // }}
                                    body={(rowData) => {
                                      const requestItem = rowData?.purchase_order_request_item;
                                      if (!requestItem?.material?.name) return null;
                                      return (
                                        <>
                                          {requestItem.material.name}
                                        </>
                                      );
                                    }}
                                  ></Column> */}
                                <Column header={t('columnQuantity')} field={"quantity"} className={"p-text-right"}
                                        body={(rowData) => {
                                          return (
                                            <div className="p-d-flex p-jc-end p-ai-center" style={{ gap: 8 }}>
                                              <span>
                                                {Number(rowData?.quantity)} {parentRow?.unit?.name}
                                              </span>
                                            </div>
                                          );
                                        }}
                                ></Column>
                                <Column className='p-text-right' header={t('columnOperation')} body={(rowData) => {
                                          const requestItem = rowData?.purchase_order_request_item;
                                          const isSubEnabled = requestItem?.substitution_enabled === true;
                                          const buttonLabel = isSubEnabled ? 'Kiváltás' : 'Csere';
                                          return (
                                            <div className="p-d-flex p-jc-end p-ai-center" style={{ gap: 8 }}>
                                              {requestItem && (
                                                <a
                                                  onClick={() => {
                                                    if (!isEditablePurchaseOrder) return;
                                                    history.push(
                                                    '/procurement/' + entity + '/' + action + '/' + id + '?search=material&requestItemId=' + rowData.id
                                                  );
                                                  }}
                                                  className={
                                                    "p-button p-button-sm " +
                                                    (isSubEnabled ? "p-button-secondary" : "p-button-warning") +
                                                    (!isEditablePurchaseOrder ? " p-disabled" : "")
                                                  }
                                                  aria-disabled={!isEditablePurchaseOrder}
                                                >
                                                  <i className="pi pi-sync"></i>
                                                  &nbsp;
                                                  {buttonLabel}
                                                </a>
                                              )}
                                            </div>
                                          );
                                        }}/>
                              </DataTable>
                            </div>
                           </div>
                           <div className="expanded-section expanded-section--inventory">
                            <h4 className="expanded-section__title">
                              <i className="pi pi-box" />
                              {t('warehouseStock')}
                            </h4>

                            <div className="expanded-section__content">
                              <DataTable
                                size="small"
                                autoLayout
                                value={invItems}
                                responsiveLayout="scroll"
                                stripedRows
                                dataKey="id"
                                loading={invLoading}
                                emptyMessage={invLoading ? t('loading') : t('noProduct')}
                              >
                                <Column header={t('columnWarehouse')} body={(rowData) => <>{rowData?.warehouse?.name || ''}</>} />

                                <Column header={t('columnAvailableStock')} className="p-text-right" 
                                  body={(rowData) => <>{Number(rowData?.quantity || 0)} {rowData?.unit?.name || ''}</>} 
                                />
                                
                                <Column header={t('columnReservedStock')} className="p-text-right"
                                  body={(rowData) => <>{Number(rowData?.quantity_reserved || 0)} {rowData?.unit?.name || ''}</>}
                                />

                                <Column header={t('columnLastMovementDate')} className="p-text-right" 
                                  body={(rowData) => <>{rowData?.last_movement_date || '—'}</>} 
                                />
                                <Column header={t('columnOperation')} className="p-text-right" body={(invRow) => {
                                    const poWarehouseId = purchaseorder?.warehouse?.id || null;
                                    const invWarehouseId = invRow?.warehouse?.id || null;
                                    if (!poWarehouseId || !invWarehouseId) return null;
                                    if (Number(poWarehouseId) === Number(invWarehouseId)) return null;
                                    return (
                                      <Button
                                        label={t('stockRelocation')}
                                        icon="pi pi-arrow-right-arrow-left"
                                        className="p-button-sm p-button-warning"
                                        disabled={!isEditablePurchaseOrder}
                                        onClick={() => openTransferDialog(parentRow, invRow)}
                                      />
                                    );
                                  }}
                                />
                              </DataTable>
                            </div>
                          </div>                
                         </>
                       )
                     }}
                     expandedRows={expandedRows}
                     onRowToggle={(e) => {
                      const rows = e.data;
                      if (!rows || Object.keys(rows).length === 0) {
                        setExpandedRows(null);
                        return;
                      }
                      const id = Object.keys(rows)[0];
                      setExpandedRows({[id]: true});
                    }}
                     onRowExpand={(e) => {
                       const row = e.data;
                       setExpandedRows({ [row.id]: true });
                       const materialId = row?.material?.id || row?.material;
                       loadInventoryForMaterial(materialId);
                     }}

          >
            <Column header={t('columnTechnology')}  body={productionItemBodyTemplate} style={{ width: '250px' }} />
            <Column field="material.manufacturer.name" header={t('columnManufacturer')} sortable filter></Column>
            <Column field="material.name" header={t('columnName')} sortable filter></Column>
            <Column field="material.upc" header={t('upc')} sortable filter></Column>
            <Column field="on_stock" header={t('columnStockItem')} bodyClassName="col-body-font-bold" sortable body={(rowData) => {
                    return (
                      <>
                        {rowData.on_stock === true ? (
                          <i className={"pi pi-check text-success"}></i>
                        ) : (
                          <i className={"pi pi-times text-danger"}></i>
                        )}
                      </>
                    )}}></Column>
            {/* <Column field="quantity" header={t('columnQuantity')} sortable filter className={"p-text-right"}
                    body={(rowData) => {
                      return (
                        <>
                          {Number(rowData?.quantity)} {rowData?.unit?.name}
                        </>
                      )
                    }}
            ></Column> */}
            {/* {props.mode === 'order' ? (
              <Column field="quantity" header={t('columnRequestedQuantity')} sortable className={"p-text-right"}
                body={(rowData) => {
                  const disabled = !canEditPo;
                  return (
                    <div className="p-d-flex p-jc-end p-ai-center" style={{ gap: 4 }}>
                      <InputNumber
                        minFractionDigits={0}
                        maxFractionDigits={9}
                        disabled={disabled}
                        locale="hu-HU"
                        id={"quantity-" + rowData.id}
                        value={rowData.quantity}
                        className={"p-inputtext-sm p-text-right"}
                        onValueChange={(e) => {
                          if (disabled) return;
                          setPurchaseorderitems(prev =>
                            prev.map(item =>
                              item.id === rowData.id ? { ...item, quantity: e.value } : item
                            )
                          );
                          if (!window.dndTimeout) {
                            window.dndTimeout = {};
                          }
                          if (window.dndTimeout[rowData.id]) {
                            clearTimeout(window.dndTimeout[rowData.id]);
                          }
                          window.dndTimeout[rowData.id] = setTimeout(function () {
                            setLoadingItem(true);
                            apiCall('patch', '/api/v2/purchase-order-item/' + rowData.id, {
                              quantity: e.value,
                            })
                              .then((response) => {
                                clearInterval(window.dndInterval[rowData.id]);
                                window.App.toastShow('success', 'Sikeres mentés!');
                              })
                              .catch((error) => {
                                clearInterval(window.dndInterval[rowData.id]);
                                window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                              })
                              .finally(() => {
                                setLoadingItem(false);
                              });
                          }, 400);
                        }}
                      />
                      {rowData?.unit?.name && (
                        <span style={{ whiteSpace: 'nowrap' }}>
                          {rowData.unit.name}
                        </span>
                      )}
                    </div>
                  );
                }}
              />
            ) : ( */}
              <Column
                field="quantity"
                header={t('columnRequested')}
                sortable
                filter
                body={(rowData) => (
                  <>
                    {Number(rowData?.quantity)} {rowData?.unit?.name}
                  </>
                )}
              />
            {/* )} */}


            <Column field="quantity_ordered" header={t('columnOrdered')} sortable filter body={(rowData) => (
              <>
                {Number(rowData?.quantity_ordered)} {rowData?.unit?.name}
              </>
            )}></Column>
            <Column field="quantity_received" header={t('columnReceived')} sortable filter body={(rowData) => (
              <>
                {Number(rowData?.quantity_received)} {rowData?.unit?.name}
              </>
            )}></Column>
            <Column header={t('columnWaitingForProcurement')} sortable filter body={(rowData) => {
              const qty = Number(rowData?.quantity || 0);
              const ordered = Number(rowData?.quantity_ordered || 0);
              const waiting = Math.max(0, qty - ordered);
              return `${waiting} ${rowData?.unit?.name || ''}`.trim();
            }}>
            </Column>

            {/* {props.mode === 'order' &&
              <Column header={t('columnUnitPrice')} body={(rowData) => {
                return (
                  <InputNumber minFractionDigits={0}
                               maxFractionDigits={9}
                               disabled={purchaseorder.status !== 'COMPOSED'}
                               locale="hu-HU"
                               id={"price-" + rowData.id}
                               onValueChange={(e) => {
                                 if (!window.dndInterval) {
                                   window.dndInterval = {};
                                 }
                                 if (window.dndInterval[rowData.id]) {
                                   clearInterval(window.dndInterval[rowData.id]);
                                 }
                                 window.dndInterval[rowData.id] = setInterval(function () {
                                   setLoadingItem(true);
                                   apiCall('patch', '/api/v2/purchase-order-item/' + rowData.id, {
                                     unit_price: e.value,
                                   })
                                     .then(response => {
                                       clearInterval(window.dndInterval[rowData.id]);
                                       window.App.toastShow('success', 'Sikeres mentés!');
                                     })
                                     .catch(error => {
                                       clearInterval(window.dndInterval[rowData.id]);
                                       window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                     })
                                     .finally(() => {
                                       setLoadingItem(false);
                                     });
                                 }, 400);
                               }}
                               value={rowData.unit_price}
                               className={"p-inputtext-sm"}
                  />
                )
              }}></Column>
            }
            {props.mode === 'order' &&
              <Column header={t('columnVat')} body={(rowData, {rowIndex}) => {
                const disabled = purchaseorder.status !== 'COMPOSED';
                return (
                  <span className="p-inputgroup">
                  <Dropdown
                    onChange={(e) => {
                      rowData.vat_rate = e.value
                      setLoadingItem(true);
                      apiCall('patch', '/api/v2/purchase-order-item/' + rowData.id, {
                        vat_rate: e.value,
                      })
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres mentés!');
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoadingItem(false);
                        });
                    }}
                    value={rowData?.vat_rate?.id || rowData?.vat_rate}
                    options={vatRates}
                    optionLabel="label"
                    optionValue="id"
                    disabled={purchaseorder.status !== 'COMPOSED'}
                    id={"vatrate-" + rowData.id}
                    emptyMessage={t('noVatYet')}
                    className={"p-inputtext-sm"}
                  />
                  <Button
                    type="button"
                    icon="pi pi-copy"
                    className="p-button-text p-button-sm"
                    title="ÁFA másolása minden további tételre"
                    disabled={disabled || rowData?.vat_rate == null || rowData?.vat_rate === ''}
                    onClick={() =>
                      copyValueToItems(
                        'vat_rate',
                        rowIndex,
                        (rowData?.vat_rate?.id || rowData?.vat_rate),
                        'all'
                      )
                    }
                  />
                </span>
                )
              }}></Column>
            }
            {props.mode === 'order' &&
              <Column header={t('columnSupplier')} body={(rowData, {rowIndex}) => {
                const disabled = purchaseorder.status !== 'COMPOSED';
                return (
                  <span className="p-inputgroup">
                  <Dropdown
                    onChange={(e) => {
                      rowData.supplier = e.value
                      setLoadingItem(true);
                      apiCall('patch', '/api/v2/purchase-order-item/' + rowData.id, {
                        supplier: e.value,
                      })
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres mentés!');
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoadingItem(false);
                        });
                    }}
                    value={rowData?.supplier?.id || rowData?.supplier}
                    options={partners}
                    optionLabel="name"
                    filter={true}
                    optionValue="id"
                    disabled={purchaseorder.status !== 'COMPOSED'}
                    id={"supplier-" + rowData.id}
                    emptyMessage={t('noSupplierYet')}
                    className={"p-inputtext-sm"}
                  />
                  <Button
                    type="button"
                    icon="pi pi-copy"
                    className="p-button-text p-button-sm"
                    title="ÁFA másolása minden további tételre"
                    disabled={disabled || rowData?.vat_rate == null || rowData?.vat_rate === ''}
                    onClick={() =>
                      copyValueToItems(
                        'supplier',
                        rowIndex,
                        (rowData?.supplier?.id || rowData?.supplier),
                        'all'
                      )
                    }
                  />
                </span>
                )
              }}></Column>
            } */}
            {props.mode === 'order' &&
              <Column expander style={{width: '3em'}}/>
            }
          </DataTable>
          <Dialog
            header={t('stockRelocationDialog')}
            visible={transferDialogVisible}
            style={{ width: '520px' }}
            modal
            closable={!transferSubmitting}
            onHide={closeTransferDialog}
            footer={
              <div className="p-d-flex p-jc-end" style={{ gap: 8 }}>
                <Button
                  label={t('cancel')}
                  className="p-button-text"
                  disabled={transferSubmitting}
                  onClick={closeTransferDialog}
                />
                <Button
                  label={t('stockRelocation')}
                  icon="pi pi-check"
                  className="p-button-warning"
                  loading={transferSubmitting}
                  onClick={async () => {
                    const parentRow = transferContext?.parentRow;
                    const invRow = transferContext?.invRow;
                    const poWarehouseId = purchaseorder?.warehouse?.id || purchaseorder?.warehouse || null;
                    const invWarehouseId = invRow?.warehouse?.id || invRow?.warehouse || null;
                    const qty = Number(transferQty || 0);
                    const inventoryId = invRow?.id;
                    if (!parentRow?.id || !invRow?.id) {
                      return;
                    }
                    if (!poWarehouseId || !invWarehouseId) {
                      window.App.toastShow('error', t('toastError'), t('missingWarehouseIdentifier'));
                      return;
                    }
                    if (qty <= 0) {
                      window.App.toastShow('error', t('toastError'), t('quantityCannotBeZero'));
                      return;
                    }
                    // if (!transferTargetLocationId) {
                    //   window.App.toastShow('error', 'Hiba', 'Válassz cél tárhelyet.');
                    //   return;
                    // }
                    setTransferSubmitting(true);
                    try {
                      await apiCall('post', `/api/v2/purchase-order-item/${parentRow.id}/move-inventory`, {
                        inventory: inventoryId,
                        warehouse_from: invWarehouseId,
                        quantity: qty,
                        warehouse_location: transferTargetLocationId,
                      });
                      window.App.toastShow('success', t('toastSuccess'), t('stockRelocationStarted'));
                      const materialId = parentRow?.material?.id || parentRow?.material;
                      if (materialId) {
                        await loadInventoryForMaterial(materialId, true);
                      }
                      loadLazyData();
                      setTransferDialogVisible(false);
                    } catch (err) {
                      window.App.toastShow('error', t('error'), err.toString(), '', err.response);
                    } finally {
                      setTransferSubmitting(false);
                    }
                  }}
                />
              </div>
            }
          >
            {(() => {
              const invRow = transferContext?.invRow;
              const poWarehouseId = purchaseorder?.warehouse?.id || purchaseorder?.warehouse || null;
              const locOptions = poWarehouseId ? (warehouseLocationsByWarehouse[poWarehouseId] || []) : [];
              const locLoading = poWarehouseId ? !!warehouseLocationsLoadingByWarehouse[poWarehouseId] : false;
              const freeQty = Number(invRow?.quantity || 0) - Number(invRow?.quantity_reserved || 0);
              const exceedsFreeStock = Number(transferQty || 0) > freeQty;
              return (
                <div className="p-fluid">
                  <div className="p-field">
                    <label>{t('fieldQuantity')} ({t('freeQuantity')}: {freeQty})</label>
                    <InputNumber
                      value={transferQty}
                      onValueChange={(e) => setTransferQty(e.value)}
                      min={0}
                      mode="decimal"
                      minFractionDigits={0}
                      maxFractionDigits={9}
                      locale="hu-HU"
                      disabled={transferSubmitting}
                      inputStyle={exceedsFreeStock ? {borderColor: 'var(--red-500)'} : undefined}
                      aria-invalid={exceedsFreeStock}
                    />
                    {exceedsFreeStock && (
                      <small className="p-d-block" style={{color: 'var(--red-500)'}}>
                        {t('quantityCannotExceedFreeStock')}
                      </small>
                    )}
                  </div>

                  {purchaseorder?.warehouse?.warehouse_location_required === true && (
                    <div className="p-field">
                      <label>{t('fieldTargetWarehouseLocation')}</label>
                      <Dropdown
                        value={transferTargetLocationId}
                        options={locOptions}
                        optionLabel="label"
                        optionValue="value"
                        filter
                        showClear
                        disabled={transferSubmitting}
                        placeholder={locLoading ? t('loading') : t('selectPlaceholder')}
                        onShow={() => {
                          if (poWarehouseId) loadWarehouseLocations(poWarehouseId);
                        }}
                        onChange={(e) => setTransferTargetLocationId(e.value || null)}
                        appendTo={document.body}
                      />
                    </div>
                  )}
                </div>
              );
            })()}
          </Dialog>
        </>
      {/*// ) : (*/}
      {/*//   <p>*/}
      {/*//     Csak folyamatban lévő vagy összeállított státuszú megrendelés adatai módosíthatóak.*/}
      {/*//   </p>*/}
      {/*// )}*/}
    </>
  )
}
export default withTranslation('common')(PurchaseorderitemListComponent);
